<div class="showTxt">
  <p [innerHTML]="isExpanded ? text : (text | slice:0:size)"></p>
  <button *ngIf="shouldShowButton" (click)="toggleExpansion()">
    {{ isExpanded ? 'Show Less' : 'Show More' }}
  </button>
</div>
